import { useEffect } from "react";

/**
 * Calls the provided onClose callback when the device orientation changes.
 *
 * @param {boolean} isOpen - Whether the menu/context menu is open.
 * @param {Function} onClose - Function to call to close the menu.
 */
export function useOrientationClose(isOpen, onClose) {
  useEffect(() => {
    if (!isOpen) return;
    const handleOrientationChange = () => onClose();
    window.addEventListener("orientationchange", handleOrientationChange);
    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, [isOpen, onClose]);
}